import wxShare from "@/mixins/wxShare";
export default {
    methods: {
        updateWXShareInfo() {
            const BASEURL = window.location.href.split("#")[0];
            const config = {
                title: document.title,
                desc: "",
                imgUrl: "",
                // 当前网站加密url传参，后端鉴权接收时对应解密
                link: BASEURL,
                // 分享的url链接，安全域名和这个分享进入的域名要一致
                shareLink: location.href,
            };
            // 启用分享
            wxShare.updateWxShareConfig(config);
        },
    },
}